<!-- 左侧描述 -->
<template>
  <div id='leftDescription'>
    <h5>完成说明</h5>
    <div v-for="(item, index) in content" :key="index" class="content">
      <img :src="`/img/0${index+1}.png`" :alt="index+1" class="content-img">
      <span>{{content[index]}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    content: Array
  },
  components: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang='scss'>
#leftDescription{
  height: 100%;
  background: #fff;
  border-radius: 12px;
  margin-top: 20px;
  margin-right: 20px;
  padding: 30px;
  text-align: left;
  h5{
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
    &::after{
      content: ' ';
      display: inline-block;
      width: 200px;
      height: 1px;
      background: rgba(239,242,245,1);
    }
  }
  .content{
    line-height: 22px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
    .content-img{
      width: 24px;
      height: 24px;
      margin-right: 10px;
      vertical-align: top;
    }
    span{
      display: inline-block;
      width: 160px;
    }
  }
}
</style>
